import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useLanguage } from '../../contexts/LanguageContext';
import LoginScreen from './LoginScreen';
import RegisterScreen from './RegisterScreen';
import ForgotPasswordScreen from './ForgotPasswordScreen';
import { Loader, Globe } from 'lucide-react';

const AuthWrapper = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  const { language, changeLanguage, t } = useLanguage();
  const [currentScreen, setCurrentScreen] = useState('login'); // login, register, forgot

  // Show loading spinner while checking authentication
  if (loading) {
    return (
      <div className="auth-screen loading-screen">
        <div className="loading-container">
          <div className="loading-spinner">
            <Loader size={32} className="spinner" />
          </div>
          <p className="loading-text">{t('loading')}</p>
        </div>
      </div>
    );
  }

  // If authenticated, show main app
  if (isAuthenticated) {
    return children;
  }

  // Language switcher component
  const LanguageSwitcher = () => (
    <div className="language-switcher">
      <button
        onClick={() => changeLanguage(language === 'en' ? 'tr' : 'en')}
        className="language-toggle"
      >
        <Globe size={16} />
        <span>{language === 'en' ? 'TR' : 'EN'}</span>
      </button>
    </div>
  );

  // Render appropriate auth screen
  const renderAuthScreen = () => {
    switch (currentScreen) {
      case 'register':
        return (
          <RegisterScreen
            onSwitchToLogin={() => setCurrentScreen('login')}
          />
        );
      case 'forgot':
        return (
          <ForgotPasswordScreen
            onBackToLogin={() => setCurrentScreen('login')}
          />
        );
      default:
        return (
          <LoginScreen
            onSwitchToRegister={() => setCurrentScreen('register')}
            onSwitchToForgot={() => setCurrentScreen('forgot')}
          />
        );
    }
  };

  return (
    <div className="auth-wrapper">
      <LanguageSwitcher />
      {renderAuthScreen()}
    </div>
  );
};

export default AuthWrapper;